import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Perimeter } from 'app/interfaces/perimeter.interface';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { FilterOptions } from '../interfaces/filter-options.interface';
import { Filter } from '../interfaces/filter.interface';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  private http = inject(HttpClient);

  private _filter$ = new BehaviorSubject<Filter>({
    contract: null,
    geocodes: [],
    techno: null,
  } as Filter);
  public filter$: Observable<Filter> = this._filter$.asObservable();

  private _filterOptions$ = new BehaviorSubject<FilterOptions>({
    contracts: [],
    geocodes: [],
    technos: [],
  } as FilterOptions);
  public filterOptions$: Observable<FilterOptions> = this._filterOptions$.asObservable();

  public hasPerimeter$: Observable<boolean> = this.filter$.pipe(map(() => this.hasPerimeter()));
  public needsPerimeter$: Observable<boolean> = this.hasPerimeter$.pipe(map((value) => !value));

  fetchOptions(): Observable<FilterOptions> {
    return this.http
      .get<FilterOptions>(`${environment.apiUrl}/filters`)
      .pipe(tap((options) => this._filterOptions$.next(Object.freeze(options))));
  }

  getOptions(): FilterOptions {
    return this._filterOptions$.getValue();
  }

  setFilter(filter: Filter) {
    this._filter$.next(filter);
  }

  getFilter(): Filter {
    return this._filter$.getValue();
  }

  getContract(): string | null {
    return this.getFilter().contract ?? null;
  }

  getGeocodes(): string[] {
    return this.getFilter().geocodes ?? [];
  }

  getTechno(): string | null {
    return this.getFilter().techno ?? null;
  }

  hasPerimeter(): boolean {
    return this.getContract() !== null && this.getTechno() !== null;
  }

  getPerimeter(): Perimeter {
    return {
      contract: this.getContract(),
      geocodes: this.getGeocodes(),
      techno: this.getTechno(),
    };
  }

  toParams() {
    return {
      contract: this.getContract(),
      geocodes: this.getGeocodes(),
      techno: this.getTechno(),
    };
  }
}
